export default __webpack_public_path__ + "static/media/Ea-mEa8g.2bf02bbb.gif";